import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [variant, setVariant] = useState('default');
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 260, damping: 24, mass: 0.6 });
  const ry = useSpring(y, { stiffness: 260, damping: 24, mass: 0.6 });

  useEffect(() => {
    const fine = window.matchMedia('(pointer: fine)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return;
    setEnabled(true);
    document.body.classList.add('custom-cursor');

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest('[data-cursor="toon"]');
      if (t) return setVariant('toon');
      if (e.target.closest('a, button, [role="button"], [data-cursor]')) return setVariant('hover');
      setVariant('default');
    };
    window.addEventListener('mousemove', move, { passive: true });
    window.addEventListener('mouseover', over, { passive: true });
    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseover', over);
      document.body.classList.remove('custom-cursor');
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        aria-hidden="true"
        className="pointer-events-none fixed left-0 top-0 z-[400] h-2 w-2 rounded-full bg-electric"
        style={{ x, y, translateX: '-50%', translateY: '-50%' }}
        animate={{
          boxShadow: ['0 0 8px rgba(0,200,255,0.9)', '0 0 18px rgba(0,200,255,0.9)', '0 0 8px rgba(0,200,255,0.9)']
        }}
        transition={{ duration: 2, repeat: Infinity }}
      />
      <motion.div
        aria-hidden="true"
        className="pointer-events-none fixed left-0 top-0 z-[399] flex items-center justify-center rounded-full border"
        style={{ x: rx, y: ry, translateX: '-50%', translateY: '-50%' }}
        animate={{
          width: variant === 'toon' ? 76 : variant === 'hover' ? 52 : 30,
          height: variant === 'toon' ? 76 : variant === 'hover' ? 52 : 30,
          borderColor:
            variant === 'toon' ? 'rgba(255,181,46,0.9)' : 'rgba(0,200,255,0.65)',
          backgroundColor: variant === 'toon' ? 'rgba(255,181,46,0.08)' : 'rgba(0,200,255,0.05)'
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 22 }}
      >
        {variant === 'toon' && (
          <span className="font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-gold">
            OPEN
          </span>
        )}
      </motion.div>
    </>
  );
}
